import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OidcSecurityService } from "angular-auth-oidc-client";
import { firstValueFrom } from "rxjs";

export const AuthGuard: CanActivateFn = async () => {
  const oidc = inject(OidcSecurityService);
  const { isAuthenticated } = await firstValueFrom(oidc.checkAuth());
  return isAuthenticated;
}
